import React from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import RecordPickerController from '../controllers/RecordPickerController';
import SearchResultRow, {
  NAME_WIDTH,
  WORKSPACE_WIDTH,
} from './SearchResultRow';
import LoadingRow from './LoadingRow';
import { type PickableRecord } from '../types/PickableRecord';

interface SearchResultsProps {
  results: PickableRecord[];
}

const SearchResults: React.FC<SearchResultsProps> = ({ results }) => {
  const controller = useController(RecordPickerController);
  const { loading } = controller.state;

  return (
    <div className='tw-grow'>
      <table className='plain-table plain-table--selectable-rows tw-w-full'>
        <colgroup>
          <col />
          <col />
          <col />
          <col style={{ minWidth: NAME_WIDTH }} />
          <col style={{ minWidth: WORKSPACE_WIDTH }} />
          <col className='plain-table--right-aligned' />
        </colgroup>
        <thead>
          <tr>
            <th> </th>
            <th> </th>
            <th>ID</th>
            <th>Name</th>
            <th>Workspace</th>
            <th className='tw-text-right'>Status</th>
          </tr>
        </thead>
        <tbody>
          {loading
            ? new Array(10).fill(0).map((n, i) => <LoadingRow key={i} />)
            : results.map(result => (
                <SearchResultRow
                  key={result.searchableIdentifier}
                  result={result}
                />
              ))}
        </tbody>
      </table>
    </div>
  );
};

export default ApplicationView(SearchResults);
